import React from 'react'
import { ChangeEvent, useState } from 'react'

import AddressBlock from './AddressBlock'
import AddressForm from './AddressForm'
import { AddressProps, CountriesProps } from '../../../shared/Module'

interface AddressesBlockProps {
  addAddressURL: string
  addresses: Array<AddressProps>
  civility: string
  countries: CountriesProps
  firstName: string
  lastName: string
  kind: 'billing' | 'shipping'
  onCreateOrUpdate: Function
  onSelect: Function
  selectedId?: number
}

const AddressesBlock = ({
  addAddressURL,
  addresses,
  countries,
  kind,
  onCreateOrUpdate,
  onSelect,
  selectedId,
  // Pre-fill customer infos on address creation
  civility,
  firstName,
  lastName,
}: AddressesBlockProps) => {
  const [addressToUpdate, setAddressToUpdate] = useState<AddressProps | null>(
    null
  )
  const [newAddress, setNewAddress] = useState(false)

  const onCancel =
    addresses.length > 0
      ? addressToUpdate
        ? () => setAddressToUpdate(null)
        : handleNewAddress
      : undefined

  if (addresses.length === 0 || newAddress || addressToUpdate) {
    return (
      <AddressForm
        address={addressToUpdate}
        civility={civility}
        countries={countries}
        firstName={firstName}
        lastName={lastName}
        kind={kind}
        onSubmit={handleCreateOrUpdate}
        onCancel={onCancel}
        url={addAddressURL}
      />
    )
  }

  return (
    <div className='o-layout o-layout--wrap o-layout--start-x c-form__details'>
      {addresses.map((address) => (
        <AddressBlock
          {...address}
          key={`shipping-${address.id}`}
          checked={selectedId === address.id}
          country={
            countries.find(({ code }) => code === address.countryCode)?.name
          }
          kind={kind}
          onChange={handleSelect}
          onUpdate={handleUpdate}
        />
      ))}
      {!newAddress && (
        <button
          className='o-layout__item o-layout__item-3-cols c-btn c-btn--secondary'
          onClick={handleNewAddress}
        >
          Ajouter une nouvelle adresse
        </button>
      )}
    </div>
  )

  // Hide form, back to addresses blocks display
  function handleCreateOrUpdate(...args: any) {
    if (addressToUpdate) {
      setAddressToUpdate(null)
    } else {
      setNewAddress(false)
    }
    onCreateOrUpdate(...args)
  }

  function handleNewAddress() {
    // Empty actual billing address when waiting for new address creation
    if (!newAddress) {
      onSelect(undefined, kind)
    }
    setNewAddress(!newAddress)
  }

  function handleSelect({ target: { value } }: ChangeEvent<HTMLInputElement>) {
    onSelect(Number(value), kind)
  }

  function handleUpdate(address: AddressProps) {
    setAddressToUpdate(address)
  }
}

export default AddressesBlock
